module.exports = __webpack_public_path__ + "media/images/icons/country_flags/pc-d669f78a433eced98974e596ceedc9ec.svg";